export default __webpack_public_path__ + "static/media/target_black.fcb729f8.png";